import React from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { Subscribe, appContainer } from '../../../../contexts/app';
import './style.scss';

class SidebarPageComponent extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    return (
      <div className={this.props.open ? 'sidebar-page open' : 'sidebar-page'}>
        <div>{[this.props.children]}</div>
      </div>
    );
  }
}

SidebarPageComponent.propTypes = {
  open: PropTypes.bool.isRequired
};

const SidebarPage = props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <SidebarPageComponent
            {...props}
            open={app.state.get('sidebarOpen')}
          />
        );
      }}
    />
  );
};

export default SidebarPage;



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/SidebarPage/index.jsx